export interface IAudioDriver {
  load(path: string): void
  play(fileId: string): void
  pause(fileId: string): void
  stop(fileId: string): void
}

export class AudioService {
  driver: IAudioDriver

  constructor(audioDriver: IAudioDriver) {
    this.driver = audioDriver
  }

  load(path: string) {
    this.driver.load(path)
  }

  play(fileId: string) {
    return this.driver.play(fileId)
  }

  pause(fileId: string) {
    return this.driver.pause(fileId)
  }

  stop(fileId: string) {
    return this.driver.stop(fileId)
  }
}
